/** @format */

// vendor
import { defineComponent, ref, computed } from "@vue/composition-api";
// project
import { Widget } from "@/psychlab/types/widget";
import * as StudyAPI from "@/services/api/studies";
// import { ImportFile } from "@/components.generic/utility-modal";
import { downloadFile, readFile } from "@/utils/file";
import { CreateWizard, ICreateWizard } from "@/components.studies/study-widget-wizard";
// import * as AppModal from "@/AppModal";
// local
import DisplayWidget from "../vue/display-widget.vue";
// import AddWidgetButton from "../vue/add-widget-button.vue";
// import { EditWidget, EditWidgetArgs } from "../vue/modal";
import GridToolbar from "../vue/grid-toolbar.vue";

type WidgetJSON = {
	type:string,
	name:string,
	args:any,
	renderTemplate:string,
};

export const WidgetGrid = defineComponent({
	props: {
		studyId: {
			type: String,
			required: true,
		},
	},
	components: {
		DisplayWidget,
		// AddWidgetButton,
		// EditWidgetArgs,
		// EditWidget,
		// ConfirmDelete,
		GridToolbar,
		// ImportFile,
		CreateWizard,
	},
	setup(props) {

		const displayWidgets = ref<any[]>([]);
		// const editArgsModal = ref<any>();
		// const confirmDeleteModal = ref<any>();
		// const importFileModal = ref<any>();
		const widgets = ref<Widget[]>([]);
		const createWizard = ref<ICreateWizard>();

		// const editWidgetModal = ref<any>();

		const editing = ref<boolean>(false);

		const loading = ref(false);

		const sortedWidgets = computed(() => {
			return widgets.value.sort((a, b) => Date.parse(b.modified) - Date.parse(a.modified));
		});

		const loadData = async () => {
			loading.value = true;
			try {
				const w =  await StudyAPI.getWidgets(props.studyId);
				widgets.value = w;
			} catch(err){
				console.error(err);
			}
			loading.value = false;
		};

		const onWidgetRefreshed = (id:string, data:any) => {
		};

		const insertWidget = (w:Widget) => {
			widgets.value.push(w);
			setTimeout(() => {
				refreshWidget(w._id);
			},1);
		};

		const getWidgetsFile = ():WidgetJSON[] => {
			// return widgets.value.map(w => {
			// 	return {
			// 		type:w.type,
			// 		name:w.name,
			// 		args:w.args,
			// 		renderTemplate:w.renderTemplate
			// 	}
			// });
			return [];
		};

		const refreshWidget = (id:string) => {
			const w = displayWidgets.value.find(dw => dw.widget._id === id);
			if(!w){ return; }
			w.refresh();
		};

		const refreshWidgets = () => {
			displayWidgets.value.forEach(w => w.refresh() );
		};

		// const editWidget = (id:string) => {
		// 	if(!editWidgetModal.value){ return; }
		// 	const widget = widgets.value.find(w => w._id === id);
		// 	if(!widget){ return; }

		// 	editWidgetModal.value.open({
		// 		widget
		// 	}, async (r:{ args?:any, renderTemplate?:string }) => {

		// 		if(r.args){
		// 			await StudyAPI.setWidgetArgs(props.studyId, widget._id, r.args);
		// 			widget.computeArgs = r.args;
		// 		}

		// 		if(r.renderTemplate){
		// 			await StudyAPI.editWidget(props.studyId, widget._id, {
		// 				renderTemplate:r.renderTemplate
		// 			});
		// 			widget.template = r.renderTemplate;
		// 		}

		// 		refreshWidget(widget._id);
		// 	});

		// };

		const onWidgetDeleted = (id:string) => {
			const i = widgets.value.findIndex(w => w._id === id);
			if(i < 0) { return; }
			widgets.value.splice(i, 1);
		};
		
		const exportWidgets = () => {
			downloadFile(`${props.studyId}-widgets.json`, JSON.stringify(getWidgetsFile(), null, "\t"));
		};
		
		const addWidgets = async(widgets:WidgetJSON[]) => {

			// for(var i = 0; i < widgets.length; i++){
				
			// 	const w = widgets[i];
			// 	const widget = await StudyAPI.createWidget(props.studyId,{
					
			// 		type:w.type,
			// 		args:w.args,
			// 		renderTemplate:w.renderTemplate,
			// 	});
			// 	insertWidget(widget);
			// }
		};

		const addWidget = async() => {

			if(!createWizard.value){ return; }

			const dataChannels = await StudyAPI.getStudyDataChannels(props.studyId);

			createWizard.value.open({
				dataChannels
			}, async (result) => {
				
				const w = await StudyAPI.createWidget(props.studyId, {
					name:result.name,
					computeType:result.dataType,
					computeArgs:result.dataArgs,
					template:result.template,
					templateBindings:result.templateBindings,
					templateArgs:result.templateArgs,
					metadata:result.metadata
				});
				insertWidget(w);
			});
		};

		const importWidgets = () => {
			// if(!importFileModal.value){ return; }
			// importFileModal.value.open(async(file:File) => {
			// 	const data = await readFile(file);
			// 	addWidgets(JSON.parse(data as string));
			// });

		};

		loadData();

		return {
			editing,
			displayWidgets,
			// editArgsModal,
			// confirmDeleteModal,
			// editWidgetModal,
			// importFileModal,
			sortedWidgets,
			createWizard,
			loading,
			// editWidget,
			// onAddType,
			onWidgetDeleted,
			onWidgetRefreshed,
			refreshWidgets,
			exportWidgets,
			importWidgets,
			addWidget,
		};
	},
});